import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const { t } = useTranslation();

    return (
        <Container className="py-5">
            <Row className="justify-content-center text-center">
                <Col md={8}>
                    <h1 className="display-1 fw-bold">404</h1>
                    <h2 className="mb-4">{t('Page Not Found')}</h2>
                    <p className="lead mb-5">
                        {t('The page you are looking for does not exist or has been moved.')}
                    </p>
                    <Button as={Link} to="/" variant="primary" size="lg">
                        {t('Go to Home')}
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default NotFound;
